import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { Button } from "../_components/button.component";
import { OrganizationService } from "../_service/organization.service";
import { TextInput } from "../_components/text-input.component";
import Timezones from "../_config/timezones.config.json";
import continents from "../_config/country-codes.config.json";
import uploadIcon from "../_assets/images/upload.png";
import galleryIcon from "../_assets/images/gallery.png";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { Controller, useForm } from "react-hook-form";
import Switch from "../_components/switch.component";
import CreatableSelect from "react-select/creatable";

export const CREATE_ORGANIZATION_ROUTE = "/manage-organization";
export const ADD_ORGANIZATION_ROUTE = (tab) =>
  "/manage-organization" + "?tab=" + tab;

export function getAddOrgPageRoute(tab) {
  return "/manage-organization" + "?tab=" + tab;
}

let timezones = [];
Timezones.map((timezone) => {
  timezone.utc.map((utc) => {
    timezones.push(utc);
  });
});

timezones = timezones.sort();

let fileUploaded = null;

function CreateOrgPageComponent({ user, history, addToast }) {
  const hiddenFileInput = useRef(null);
  const sp = new URLSearchParams(window.location.search);
  const tab = sp.get("tab");
  const [orgImgUrl, setOrgImgUrl] = useState(null);
  const [orgImg, setOrgImg] = useState(null);
  const [orgImageName, setOrgImageName] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [orgName, setOrgName] = useState("");
  const [country, setCountry] = useState("India");
  const [website, setWebsite] = useState("");
  const [timezone, setTimezone] = useState("Asia/Kolkata");
  const [description, setDescription] = useState("");
  const [anonymousFeedback, setAnonymousFeedback] = useState(false);
  const [oneOnOne, setOneOnOne] = useState(true);

  const urlPattern =
    /^(https?:\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/i;
  const validateUrl = (value) =>
    urlPattern.test(value) ||
    "Please enter a valid URL starting with 'http://' or 'https://'";
  const whitespaceRegex = /^\s*$/;

  const departmentDefaultOptions = [
    { label: "Not Applicable", value: "notApplicable" },
    { label: "Breast Care", value: "breastCare" },
    { label: "Cancer Care", value: "cancerCare" },
    { label: "Cardiac Care", value: "cardiacCare" },
    { label: "Cardiopulmonary", value: "cardiopulmonary" },
    { label: "Critical Care", value: "criticalCare" },
    { label: "Diagnostic Sleep Center", value: "diagnosticSleepCenter" },
    { label: "Elderly Care", value: "elderlyCare" },
    { label: "Emergency Services", value: "emergencyServices" },
    { label: "ENT & Allergy", value: "eNTAndAllergy" },
    { label: "Hospitalists", value: "hospitalists" },
    { label: "Internal Medicine", value: "internalMedicine" },
    { label: "Medical-Surgical", value: "medicalSurgical" },
    { label: "Neurology and Neurosurgery", value: "NeurologyandNeurosurgery" },
    {
      label: "Occupational, Physical, and Speech Therapy",
      value: "occupationalPhysicalandSpeechTherapy",
    },
    { label: "Orthopedics", value: "orthopedics" },
    { label: "Palliative Care", value: "palliativeCare" },
    { label: "Pediatrics", value: "pediatrics" },
    { label: "Primary Care", value: "primaryCare" },
    { label: "Radiology", value: "radiology" },
    { label: "Rehabilitation", value: "rehabilitation" },
    { label: "Rheumatology", value: "rheumatology" },
    { label: "Stroke Care", value: "strokeCare" },
    { label: "Wound Care", value: "woundCare" },
    { label: "Other", value: "other" },
  ];

  const professionDefaultOptions = [
    { label: "Physicians", value: "physicians" },
    { label: "Nurses (non-clinical)", value: "nursesNonClinical" },
    { label: "Nurses (clinical)", value: "nurseClinical" },
    { label: "Allied Health", value: "alliedHealth" },
    { label: "Auxiliary Staff", value: "auxiliaryStaff" },
    { label: "Administrative Staff", value: "administrativeStaff" },
    { label: "Other", value: "other" },
  ];

  const [selectedDepartments, setSelectedDepartments] = useState([
    ...departmentDefaultOptions,
  ]);
  const [selectedProfessions, setSelectedProfessions] = useState([
    ...professionDefaultOptions,
  ]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    defaultValues: {
      departments: departmentDefaultOptions,
      professions: professionDefaultOptions,
    },
  });

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const isFormSubmitable =
    orgName.length >= 1 &&
    country.length >= 1 &&
    (website.startsWith("http://") || website.startsWith("https://")) &&
    description.length >= 1;

  const handleChange = (event) => {
    fileUploaded = event.target.files[0];
    setOrgImageName(fileUploaded.name);
    setOrgImg(URL.createObjectURL(fileUploaded));
  };

  const addOrganization = async (data) => {
    setIsLoading(true);
    if (orgImg) {
      const formData = new FormData();
      formData.append("file", fileUploaded, fileUploaded.name);
      await OrganizationService.uploadImage(user, formData)
        .then((resp) => {
          setOrgImgUrl(resp.url);
          addOrganizationFinal(resp.url, data);
        })
        .catch((error) => {
          addToast(
            "Unable to upload organization image",
            "",
            ToastTypes.danger
          );
          console.log(error);
          return;
        });
    }
  };

  const addOrganizationFinal = (imgUrl, formData) => {
    const orgData = {
      name: formData.name,
      country: formData.country,
      website: formData.website,
      timeZone: formData.timezone,
      description: formData.description,
      organizationLogo: imgUrl,
      anonymousFeedback,
      oneOnOne,
      additionalResources: {
        url: formData.url,
        title: formData.title,
        body: formData.body,
      },
      professions: selectedProfessions,
      departments: selectedDepartments,
    };
    OrganizationService.addOrganization(user, orgData)
      .then((resp) => {
        setIsLoading(false);
        history.push("/organizations");
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
        console.log(error);
      });
  };

  const onSubmit = (data) => {
    if (orgImg) {
      addOrganization(data);
    } else {
      addOrganizationFinal(undefined, data);
    }
  };

  const handleCreateOptionDepartment = (inputValue) => {
    const optionExists = selectedDepartments.some(
      (option) => option.label.toLowerCase() === inputValue.toLowerCase()
    );
    if (!optionExists) {
      const newOption = { value: inputValue, label: inputValue };
      setSelectedDepartments([...selectedDepartments, newOption]);
    }
  };

  const handleCreateOptionProfession = (inputValue) => {
    const optionExists = selectedProfessions.some(
      (option) => option.label.toLowerCase() === inputValue.toLowerCase()
    );
    if (!optionExists) {
      const newOption = { value: inputValue, label: inputValue };
      setSelectedProfessions([...selectedProfessions, newOption]);
    }
  };

  return (
    <div className="page-container ml-auto px-9 py-6 create-org-container">
      <div>
        <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex justify-between">
              <span className="font-bold text-xl text-primary">
                Create New Account
              </span>
            </div>
            <div className="border-b mx-8 my-6 pb-16">
              <span className="text-primary text-xl">General Information</span>
              <div className="flex general-info-container mt-8 w-4/6">
                <div className="image-pick-container">
                  <div
                    className="show-img border flex items-center rounded-md"
                    style={{ backgroundColor: !orgImg ? "#F4FAFF" : "" }}>
                    {/* <img src={orgImgUrl} alt="" className="h-full w-full rounded-md" /> */}
                    {orgImg ? (
                      <img
                        src={orgImg}
                        alt=""
                        className="h-full w-full object-contain rounded-md"
                      />
                    ) : (
                      <div>
                        <img
                          src={galleryIcon}
                          alt=""
                          className="h-10 object-contain w-full text-center flex"
                        />
                        <div className="text-xs text-center w-9/12 m-auto mt-2 t-grey">
                          Upload an image of the organization's official logo.
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="text-xxs mt-2 pb-2 t-grey">
                    (Upload file below 20MB)
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    id="my-file"
                    ref={hiddenFileInput}
                    onChange={handleChange}
                    accept="image/gif, image/jpeg, image/png"
                  />
                  <div
                    onClick={handleClick}
                    className="border py-1 flex items-center rounded-md overflow-hidden cursor-pointer justify-center">
                    <img
                      src={uploadIcon}
                      alt=""
                      className="h-5 w-5 rounded-md"
                    />
                    <div
                      className={`flex pl-2 t-grey ${
                        orgImageName ? "mr-2 pr-2 border-r" : ""
                      } `}>
                      Choose a file
                    </div>
                    {orgImageName ? (
                      <div className="z-10 w-20 overflow-x-scroll whitespace-nowrap mostly-customized-scrollbar t-grey">
                        {orgImageName}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="ml-20 detail-container w-full">
                  <div className="my-2">
                    <p htmlFor="orgname" className="text-base t-grey">
                      Organization Name*
                    </p>
                    <input
                      type="text"
                      id="name"
                      placeholder="Enter Organization Name"
                      className="py-2 items-center t-grey my-0 border p-1 rounded w-full"
                      {...register("name", {
                        required: "Enter valid organization name",
                      })}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.name?.message}
                    </p>
                    {/* <TextInput
                      key="1"
                      defaultValue={orgName}
                      value={orgName}
                      type="text"
                      validator={(value) => {
                        if (value.length <= 0) {
                          return "Enter valid organization name";
                        }
                      }}
                      placeholder="Enter Organization Name"
                      containerClassName="flex-grow block"
                      className="py-2 items-center t-grey"
                      onChange={(value) => {
                        setOrgName(value);
                      }}
                    /> */}
                  </div>
                  <div className="my-2">
                    <p htmlFor="country" className="text-base t-grey">
                      Country or Region*
                    </p>
                    <div className="">
                      <select
                        {...register("country", {
                          required: true,
                          message: "Please select an option",
                        })}
                        className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey"
                        defaultValue="India">
                        {continents.map((item, index) => {
                          return (
                            <option key={index} value={item.country}>
                              {item.country}
                            </option>
                          );
                        })}
                      </select>
                      {/* <select
                        className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                        }}>
                        {continents.map((item, index) => {
                          return (
                            <option key={index} value={item.country}>
                              {item.country}
                            </option>
                          );
                        })}
                      </select> */}
                    </div>
                    {/* <TextInput
                      type="text"
                      defaultValue={country}
                      value={country}
                      validator={(value) => {
                        if (value.length <= 0) {
                          return "Enter valid country name";
                        }
                      }}
                      placeholder="Enter Country"
                      containerClassName="flex-grow block items-center"
                      className="py-2 t-grey"
                      onChange={(value) => {
                        setCountry(value);
                      }}
                    /> */}
                  </div>
                  <div className="my-2">
                    <p htmlFor="website" className="text-base t-grey">
                      Website*
                    </p>
                    {/* <input type="text" name="website" id="website" className="border my-3 w-full h-9  rounded-md p-2"/> */}
                    <input
                      type="text"
                      id="website"
                      placeholder="https://www.google.com"
                      className="py-2 items-center t-grey my-0 border p-1 rounded w-full"
                      {...register("website", {
                        validate: validateUrl,
                        required: "Invalid website url!",
                      })}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.website?.message}
                    </p>
                    {/* <TextInput
                      type="text"
                      defaultValue={website}
                      value={website}
                      validator={(value) => {
                        if (
                          value.startsWith("http://") ||
                          value.startsWith("https://") ||
                          value.length === 0
                        ) {
                        } else {
                          return "Invalid website url!";
                        }
                      }}
                      placeholder="https://www.google.com"
                      containerClassName="flex-grow block"
                      className="py-2 t-grey items-center"
                      onChange={(value) => {
                        setWebsite(value);
                      }}
                    /> */}
                  </div>
                  <div className="my-2">
                    <p htmlFor="departments" className="text-base t-grey">
                      Department
                    </p>
                    <Controller
                      {...register("departments", {
                        required: "Department is required",
                      })}
                      control={control}
                      render={({ field, value }) => (
                        <CreatableSelect
                          {...field}
                          isMulti
                          placeholder="Select Department"
                          onChange={(item) => {
                            field.onChange(item);
                            setSelectedDepartments(item);
                          }}
                          value={selectedDepartments}
                          options={departmentDefaultOptions}
                          createOptionPosition="last"
                          isValidNewOption={(
                            inputValue,
                            selectValue,
                            selectOptions
                          ) => {
                            return inputValue.trim() !== "";
                          }}
                          onCreateOption={handleCreateOptionDepartment}
                          styles={{
                            control: (base) => ({
                              ...base,
                              boxShadow: "none",
                              border: "1px solid lightgray !important",
                              "&:hover": {
                                boxShadow: "none !important",
                                border: "1px solid lightgray !important",
                              },
                            }),
                          }}
                        />
                      )}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.departments?.message}
                    </p>
                  </div>

                  <div className="my-2">
                    <p htmlFor="professions" className="text-base t-grey">
                      Profession
                    </p>
                    <Controller
                      {...register("professions", {
                        required: "Profession is required",
                      })}
                      control={control}
                      render={({ field, value }) => (
                        <CreatableSelect
                          {...field}
                          isMulti
                          placeholder="Select Profession"
                          onChange={(item) => {
                            field.onChange(item);
                            setSelectedProfessions(item);
                          }}
                          value={selectedProfessions}
                          options={professionDefaultOptions}
                          createOptionPosition="last"
                          onCreateOption={handleCreateOptionProfession}
                          isValidNewOption={(
                            inputValue,
                            selectValue,
                            selectOptions
                          ) => {
                            return inputValue.trim() !== "";
                          }}
                          styles={{
                            control: (base) => ({
                              ...base,
                              boxShadow: "none",
                              border: "1px solid lightgray !important",
                              "&:hover": {
                                boxShadow: "none !important",
                                border: "1px solid lightgray !important",
                              },
                            }),
                          }}
                        />
                      )}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.professions?.message}
                    </p>
                  </div>

                  <div className="my-2">
                    <p htmlFor="timezone" className="text-base t-grey">
                      Timezone
                    </p>
                    <select
                      {...register("timezone", {
                        required: true,
                        message: "Please select an option",
                      })}
                      className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey"
                      defaultValue="Asia/Kolkata">
                      {timezones.map((utc, index) => {
                        return (
                          <option key={utc + index} value={utc}>
                            {utc}
                          </option>
                        );
                      })}
                    </select>
                    {/* <div className="">
                      <select
                        className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey"
                        value={timezone}
                        onChange={(e) => {
                          setTimezone(e.target.value);
                        }}>
                        {timezones.map((utc, index) => (
                          <option key={utc + index} value={utc}>
                            {utc}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                  <div className="my-2">
                    <p htmlFor="subscription" className="text-base t-grey">
                      Description*
                    </p>

                    <textarea
                      type="text"
                      rows={6}
                      id="description"
                      maxLength={250}
                      // value={description}
                      placeholder="Enter Description"
                      className="border items-center p-2 rounded t-grey w-full"
                      {...register("description", {
                        required: "Description is required",
                        maxLength: 250,
                      })}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.description?.message}
                    </p>
                  </div>
                  <div className="my-2 flex">
                    <p
                      htmlFor="additionalResourcesTitle"
                      className="text-base t-grey">
                      Anonymous Feedback Visible*
                    </p>
                    <div className="ml-2 flex">
                      {anonymousFeedback ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                      <Switch
                        className="ml-2"
                        toggle={anonymousFeedback}
                        setToggle={setAnonymousFeedback}
                      />
                    </div>
                  </div>
                  <div className="my-2 flex">
                    <p
                      htmlFor="additionalResourcesTitle"
                      className="text-base t-grey">
                      One-on-One Visible*
                    </p>
                    <div className="ml-2 flex">
                      {oneOnOne ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                      <Switch
                        className="ml-2"
                        toggle={oneOnOne}
                        setToggle={setOneOnOne}
                      />
                    </div>
                  </div>
                  <div className="my-2">
                    <p
                      htmlFor="additionalResourcesTitle"
                      className="text-base t-grey">
                      Additional Resources Title*
                    </p>
                    {/* <input type="text" name="website" id="website" className="border my-3 w-full h-9  rounded-md p-2"/> */}
                    <input
                      type="text"
                      id="additionalResourcesTitle"
                      placeholder="Enter additional resources title"
                      className="py-2 items-center t-grey my-0 border p-1 rounded w-full"
                      {...register("title", {
                        required: "additional resources title is required",
                        validate: (value) => !whitespaceRegex.test(value),
                        maxLength: {
                          value: 30,
                          message:
                            "additional resources title should not be more than 30 characters",
                        },
                      })}
                    />
                    {errors.title && errors.title?.message && (
                      <p className={`text-red-500 text-xs h-2.5`}>
                        {errors.title?.message}
                      </p>
                    )}
                    {errors.title && errors.title.type === "validate" && (
                      <p className={`text-red-500 text-xs h-2.5`}>
                        additional resources title cannot be only whitespace
                        characters
                      </p>
                    )}
                  </div>
                  <div className="my-2">
                    <p
                      htmlFor="additionalResourcesURL"
                      className="text-base t-grey">
                      Additional Resources URL*
                    </p>
                    <input
                      type="text"
                      id="additionalResourcesURL"
                      placeholder="Enter additional resources url"
                      className="py-2 items-center t-grey my-0 border p-1 rounded w-full"
                      {...register("url", {
                        validate: validateUrl,
                        required: "Invalid additional resources url!",
                      })}
                    />
                    <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.url?.message}
                    </p>
                  </div>
                  <div className="my-2">
                    <p
                      htmlFor="additionalResourcesBody"
                      className="text-base t-grey">
                      Additional Resources Body*
                    </p>
                    <textarea
                      type="text"
                      rows={6}
                      id="additionalResourcesBody"
                      // value={description}
                      placeholder="Enter additional resources body"
                      className="border items-center p-2 rounded t-grey w-full"
                      {...register("body", {
                        required: "additional resources body is required",
                        validate: (value) => !whitespaceRegex.test(value),
                        maxLength: {
                          value: 125,
                          message:
                            "additional resources body should not be more than 125 characters",
                        },
                      })}
                    />
                    {/* <p className={`text-red-500 text-xs h-2.5`}>
                      {errors.body?.message}
                    </p> */}
                    {errors.body && errors.body?.message && (
                      <p className={`text-red-500 text-xs h-2.5`}>
                        {errors.body?.message}
                      </p>
                    )}
                    {errors.body && errors.body.type === "validate" && (
                      <p className={`text-red-500 text-xs h-2.5`}>
                        additional resources body cannot be only whitespace
                        characters
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mx-8 my-6">
              <Button
                // disabled={!isFormSubmitable}
                type="submit"
                isLoading={isLoading}
                label="Save"
                className="btn-primary px-14"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
});

const CreateOrgPage = withToast(
  connect(mapStateToProps)(CreateOrgPageComponent)
);

export default CreateOrgPage;
